{
  "title": "Armor of Agathys",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level abjuration",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a cup of water)",
  "duration": "1 hour",
  "description": [
    "A protective magical force surrounds you, manifesting as a spectral frost that covers you and your gear. You gain 5 temporary hit points for the duration. If a creature hits you with a melee attack while you have these hit points, the creature takes 5 cold damage.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, both the temporary hit points and the cold damage increase by 5 for each slot."
  ],
  "spellLists": ["warlock"]
}
